// © Microsoft Corporation. All rights reserved.

import { NavItem } from "./NavItem";
import { navItemTemplate as template } from "./NavItem.template";
import { brandingStyles, navItemStyles } from "./NavItem.styles";
import { customElement } from "@microsoft/fast-element";
import { isWindowsFlightEnabled, WindowsFlights } from "@msnews/windows-shared";

const styles = isWindowsFlightEnabled(WindowsFlights.VerticalBranding1) ? [navItemStyles, brandingStyles] : navItemStyles;
@customElement({
    name: "msn-nav-item",
    template,
    styles,
    shadowOptions: {
        delegatesFocus: true
    }
})
export class MsnNavItem extends NavItem { }